import {
  Colors,
  TextBold,
  TextLight,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import {
  getFormattedLabel,
  getFormattedValue,
  type LabelFormattingOption,
  type ValueFormattingOption,
} from '@utils/formatting';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

type Props = {
  value: number | undefined;
  label: 'connection' | 'follower' | 'following' | 'event';
  valueFormatting?: ValueFormattingOption;
  labelFormatting?: LabelFormattingOption;
  onPress?: () => void;
  size?: 'small';
};

export default function ProfileStat({
  value,
  label,
  valueFormatting = 'none',
  labelFormatting = 'pluralise',
  onPress,
  size,
}: Props) {
  const styles = useDynamicStyles(createStyles, { size });

  const valueToDisplay = getFormattedValue(value, valueFormatting);
  const labelToDisplay = getFormattedLabel(label, value, labelFormatting);

  return (
    <Pressable
      style={({ pressed }) => [styles.container, pressed && styles.pressed]}
      onPress={onPress}
      disabled={value === undefined || !onPress}
    >
      <View style={styles.content}>
        <TextBold style={styles.statCount}>{valueToDisplay}</TextBold>
        <TextLight style={styles.statLabel}>{labelToDisplay}</TextLight>
      </View>
    </Pressable>
  );
}

function createStyles({ isMobile, size }: WithResponsive<Props>) {
  return StyleSheet.create({
    container: {
      minWidth: isMobile ? 110 : 120,
      paddingHorizontal: 8,
      borderRadius: 28,
      backgroundColor: 'transparent',
    },
    pressed: {
      backgroundColor: Colors.opacity20,
    },
    content: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    statCount: {
      fontSize: size === 'small' || isMobile ? 16 : 24,
      textAlign: 'center',
    },
    statLabel: {
      fontSize: size === 'small' || isMobile ? 14 : 16,
      textAlign: 'center',
    },
  });
}
